/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/
import { Dispatch, SetStateAction, useState } from 'react';
import { EvalResults } from '@/ux-common/src/types/api';
import { IPrompt } from 'types/prompt';

import { useEvals } from '@/hooks/useEvals';
import { usePrompts } from '@/hooks/usePrompts';

import { Dialog, DialogTrigger } from '../ui/dialog';
import { PromptAccordion } from './prompt-accordion';
import { PromptCard } from './prompt-card';
import { PromptDetailsModal } from './prompt-detail-modal';

export const PromptListAll = ({
  accordionValue,
  setAccordionValue,
  currentPrompts,
  selectedPrompt,
  setSelectedPrompt,
  selectedGrouping,
  startIndex,
}: {
  accordionValue: string;
  setAccordionValue: Dispatch<SetStateAction<string>>;
  currentPrompts: IPrompt[];
  selectedPrompt: IPrompt[];
  setSelectedPrompt: Dispatch<SetStateAction<IPrompt[]>>;
  selectedGrouping: string;
  startIndex: number;
}) => {
  const { state: evalState } = useEvals();
  const evalResults: EvalResults[] = evalState.traceEvals?.results;
  const [position, setPosition] = useState<number>(0);
  const { state } = usePrompts();
  const promptList = state?.promptData;
  const factsData = state?.factsData;

  const handleNext = () => {
    setPosition((prev) => prev + 1);
  };
  const handlePrev = () => {
    setPosition((prev) => prev - 1);
  };

  const matchInferenceEvalFn = (item: IPrompt): EvalResults[] | undefined => {
    if (evalResults && evalResults.length > 0) {
      return evalResults
        .filter(
          (inferenceEval) =>
            inferenceEval.fact_id === `${item.trace_id}.${item.span_id}`
        )
        .filter((inferenceEval) => inferenceEval.eval_found === true);
    }
    return undefined;
  };

  return (
    <div className="flex max-h-[814px] flex-col overflow-hidden pt-3">
      {selectedGrouping?.length > 0 ? (
        <PromptAccordion
          accordionValue={accordionValue}
          setAccordionValue={setAccordionValue}
          promptList={currentPrompts}
          factsData={factsData}
          selectedPrompt={selectedPrompt}
          setSelectedPrompt={setSelectedPrompt}
        />
      ) : (
        <ul className="flex flex-col gap-1 overflow-auto">
          {currentPrompts.map((item: IPrompt, id: number) => {
            return (
              <Dialog key={item?.span_id}>
                <DialogTrigger
                  asChild
                  onClick={() => setPosition(startIndex + id)}
                >
                  <li>
                    <PromptCard
                      selectedPrompt={selectedPrompt}
                      setSelectedPrompt={setSelectedPrompt}
                      item={item}
                      evalResults={matchInferenceEvalFn(item)}
                    />
                  </li>
                </DialogTrigger>
                <PromptDetailsModal
                  position={position}
                  data={promptList}
                  factsData={factsData}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                />
              </Dialog>
            );
          })}
        </ul>
      )}
    </div>
  );
};
